/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ShieldAlert, Check, X, RefreshCw, Lock, Info } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ActivationFakeOrders({ close }) {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [isFeatureActive, setIsFeatureActive] = useState(
    store.imaginaryDetectionApp
  );
  const [initialState, setInitialState] = useState(null);
  const { t } = useTranslation();

  const [data, setData] = useStoreFormDraft(store);

  useEffect(() => {
    if (store) {

      setInitialState({ ...store });
      setIsFeatureActive(Boolean(store.imaginaryDetectionApp));
    }
  }, [store]);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.FakeOrders.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.FakeOrders.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
    });
  };

  const hasStateChanged = () => {
    if (!initialState) return false;
    return data.imaginaryDetectionApp !== initialState.imaginaryDetectionApp;
  };

  const handleToggleChange = () => {
    setData({
      ...data,
      imaginaryDetectionApp: !data.imaginaryDetectionApp,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hasStateChanged()) {
      await showAlert(
        "info",
        t("servicePageActivation.imaginaryDetection.alert.noChange.title"),
        t("servicePageActivation.imaginaryDetection.alert.noChange.description")
      );
      return;
    }

    const isActivating = store.imaginaryDetectionApp && !isFeatureActive;
    const isDeactivating = !store.imaginaryDetectionApp && isFeatureActive;

    try {
      setLoading(true);
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));
      setLoading(false);
      setInitialState({ ...data });
      setIsFeatureActive(data.imaginaryDetectionApp);

      if (isDeactivating) {
        await showAlert(
          "success",
          t(
            "servicePageActivation.imaginaryDetection.alert.success.deactivated"
          ),
          ""
        );
      } else if (isActivating) {
        await showAlert(
          "success",
          t("servicePageActivation.imaginaryDetection.alert.success.activated"),
          ""
        );
      } else {
        await showAlert(
          "success",
          t("servicePageActivation.imaginaryDetection.alert.success.saved"),
          ""
        );
      }
      close();
    } catch (error) {
      setLoading(false);
      await showAlert(
        "error",
        t("servicePageActivation.imaginaryDetection.alert.error.title"),
        t("servicePageActivation.imaginaryDetection.alert.error.description")
      );
    }
  };

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#181919] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] dark:text-[#b47ed6] mb-2 flex items-center">
            <ShieldAlert className="ml-2" size={20} />
            {t("servicePageActivation.imaginaryDetection.title")}
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            {t("servicePageActivation.imaginaryDetection.description")}
          </p>
          <Link
            to="/plan"
            className="bg-[#9e68ba] text-white px-6 py-2 rounded-lg hover:bg-[#814a9f] transition-colors mt-3 inline-block"
          >
            <span className="text-sm font-medium">
              {t("servicePageActivation.cloakingcountries.upgradeButton")}
            </span>
          </Link>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <div className="flex justify-between items-center mb-4">
              <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ed6]">
                {t("servicePageActivation.imaginaryDetection.label")}
              </label>
              <div
                className={`px-2 py-1 rounded-full text-xs font-medium ${
                  data.imaginaryDetectionApp
                    ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:text-green-300"
                    : "bg-gray-100 text-gray-800 dark:!bg-gray-700 dark:text-gray-300"
                }`}
              >
                {data.imaginaryDetectionApp
                  ? t("servicePageActivation.imaginaryDetection.status.active")
                  : t(
                      "servicePageActivation.imaginaryDetection.status.inactive"
                    )}
              </div>
            </div>

            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                data.imaginaryDetectionApp
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181919] dark:!border-[#3c3a3d]"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181919] dark:!border-[#3c3a3d] dark:hover:bg-[#1f1f1f]"
              }`}
              onClick={handleToggleChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <div
                  className={`block overflow-hidden h-6 rounded-full cursor-pointer ${
                    data.imaginaryDetectionApp
                      ? "bg-purple-400"
                      : "bg-gray-300 dark:!bg-gray-600"
                  }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${
                      data.imaginaryDetectionApp
                        ? "translate-x-6"
                        : "translate-x-0"
                    }`}
                  />
                </div>
              </div>
              <div>
                <div className="flex items-center">
                  {data.imaginaryDetectionApp ? (
                    <Check size={18} className="ml-2 text-[#9e68ba]" />
                  ) : (
                    <X
                      size={18}
                      className="ml-2 text-gray-500 dark:text-gray-400"
                    />
                  )}
                  <p className="font-medium dark:text-gray-200">
                    {data.imaginaryDetectionApp
                      ? t(
                          "servicePageActivation.imaginaryDetection.card.active.title"
                        )
                      : t(
                          "servicePageActivation.imaginaryDetection.card.inactive.title"
                        )}
                  </p>
                </div>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                  {data.imaginaryDetectionApp
                    ? t(
                        "servicePageActivation.imaginaryDetection.card.active.description"
                      )
                    : t(
                        "servicePageActivation.imaginaryDetection.card.inactive.description"
                      )}
                </p>
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || !hasStateChanged()}
            className={`px-6 py-3 ${
              !hasStateChanged()
                ? "bg-gray-400 dark:!bg-gray-600"
                : !data.imaginaryDetectionApp && isFeatureActive
                ? "bg-red-500 hover:bg-red-600"
                : "bg-[#9b59bf] hover:bg-[#814a9f]"
            } text-white rounded-lg transition-colors flex items-center justify-center ${
              loading || !hasStateChanged()
                ? "opacity-70 cursor-not-allowed"
                : ""
            }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.imaginaryDetectionApp
                  ? t(
                      "servicePageActivation.imaginaryDetection.button.loading.activate"
                    )
                  : t(
                      "servicePageActivation.imaginaryDetection.button.loading.deactivate"
                    )}
              </>
            ) : (
              <>
                {!hasStateChanged() ? (
                  <>
                    <Info className="ml-2" size={18} />
                    {t(
                      "servicePageActivation.imaginaryDetection.button.noChange"
                    )}
                  </>
                ) : !data.imaginaryDetectionApp && isFeatureActive ? (
                  <>
                    <X className="ml-2" size={18} />
                    {t(
                      "servicePageActivation.imaginaryDetection.button.deactivate"
                    )}
                  </>
                ) : (
                  <>
                    <Check className="ml-2" size={18} />
                    {t(
                      "servicePageActivation.imaginaryDetection.button.activate"
                    )}
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
